<template>
  <div
    v-if="typeof(selected_task) !== 'undefined' && !_.isEmpty(selected_task)"
    style="background-color: #F8F9FC !important;"
    class="card m-0">
    <div class="row p-0 m-0">
      <div class="col-8 m-0 p-4 bg-white">
        <div class="row">
          <div class="col-5 m-0 p-2">
            <div class="unselectable pl-2">
              <button  v-if="selected_task.status === 'new' || selected_task.status === 'wip'" @click="selected_task.status = 'done'" class="btn btn-outline-primary btn-sm"><i class="fe fe-check-circle mr-2"></i>{{ $t("common.edit_task.mark_Complete") }}</button>
              <button  v-if="selected_task.status === 'done' || selected_task.status === 'canceled'" @click="selected_task.status = 'wip'" class="btn btn-outline-secondary btn-sm"><i class="fe fe-check-circle mr-2"></i>{{ $t("common.edit_task.back_to_work") }}</button>
              <span v-if="selected_task.status === 'deleted'" class="font-weight-bold float-left mt-1">{{ $t("common.edit_task.task_statuses.archived") }}</span>
            </div>
          </div>
          <div class="col-2"> </div>
          <div class="col-5 p-0">
            <new-person-select type="taskView"></new-person-select>
          </div>
        </div>
        <div class="col-12 p-0 mb-2 mt-4 overflow-auto">
          <textarea-autosize
            @keyup.native.enter="closeModal()"
            :placeholder="$t('common.edit_task.set_task_purpose')"
            :min-height="30"
            v-model="selected_task.name"
            ref="myTextarea"
            rows="1"
            class="form-control form-control-flush p-2 taskName animated"
          ></textarea-autosize>
          <button v-if="!show_description" @click="show_description = !show_description" class="btn float-left btn-sm btn-link text-secondary d-flex"> {{ $t("common.edit_task.add_description") }}</button>
          <button v-if="!show_subtask" @click="show_subtask = !show_subtask" class="btn float-left btn-sm btn-link text-secondary d-flex"> {{ $t("common.edit_task.add_subtask") }}</button>
        </div>
        <div v-if="show_description" class="col-12 pl-1 pt-0 mb-4 ">
          <rich-text-editor class="animated p-1"></rich-text-editor>
        </div>
        <div v-if="show_subtask" class="col-12pl-2 pl-2 mt-5">
          <label class="mb-3 leftLabels"><subtasks-icon class="mr-3" style="margin-bottom: 4px"></subtasks-icon>{{ $t("common.edit_task.subtasks") }}</label>
          <subtasks :task="selected_task"></subtasks>
        </div>
       <!-- <div class="col-8 mt-4">
          <label class="mb-3 leftLabels"><i class="fe fe-paperclip mr-2"></i>{{ $t("common.edit_task.attachments") }}</label>
          <FilePond
            class-name="my-pond"
            name="test"
            ref="pond"
            labelIdle="Drag & Drop your files or <span>Browse</span>"
            allowMultiple="true"
            acceptedFileTypes="image/jpeg, image/png"
            v-bind:files="myFiles"
          />
        </div>-->
        <edit-task-comments :taskId="selected_task._id" class="mt-4"></edit-task-comments>
      </div>
      <div class="col-4 m-0 p-4">
        <div class="card p-3">
          <label class="mb-3 small"><i class="fe fe-clock mr-2"></i>{{ $t("common.edit_task.estimated_time") }}</label>
          <duration-picker class="mb-3"></duration-picker>
          <label class="mb-3 small"><i class="fe fe-activity mr-2"></i>{{ $t("common.edit_task.actual_spent_time") }}</label>
          <duration-picker class="mb-3" :duration_actual="true"></duration-picker>

          <div class="col-auto p-0" style="min-width: 50%">
            <button
              @click="logForDay--"
              class="btn btn-xxs btn-link float-left text-muted"
            >
              <i class="fe fe-chevron-left"></i>
            </button>
            <span style="font-size: 0.75rem; margin-top: 0.1575rem" class="small float-left text-muted unselectable">{{ $t("common.edit_task.log_for") }} <u>{{ logFor | moment('Do MMM') }}</u></span>
            <button
              @click="logForDay++"
              class="btn btn-xxs btn-link float-left text-muted"
            >
              <i class="fe fe-chevron-right "></i>
            </button>
          </div>
        </div>

        <div class="card p-3">
          <label class="mb-1 small"><i class="fe fe-log-out mr-2"></i>{{ $t("common.edit_task.planing_date") }}</label>
          <date-select :plan_date="true"></date-select>
          <label class="mb-1 small"><i class="fe fe-log-in mr-2"></i>{{ $t("common.edit_task.deadline_date") }}</label>
          <date-select></date-select>
          <label class="mb-1 small"><i class="fe fe-star mr-2"></i>{{ $t("common.edit_task.priority") }}</label>
          <priority-select></priority-select>
        </div>

        <div class="card p-3" style="overflow-y: auto">
          <label class="mb-2 small"><i class="fe fe-briefcase"></i> {{ $t("common.edit_task.project") }}</label>
          <project-select :task_mode="true" :show_project_picture="false"></project-select>

          <label class="mt-2 small"><i class="fe fe-folder mr-2"></i>{{ $t("common.edit_task.section") }}</label>
          <section-select :show_project_picture="false"></section-select>

          <label class="mt-2 small" v-if="selected_task.epic_links"><i class="fe fe-bookmark mr-2"></i>{{ $t("common.edit_task.epic_links") }}</label>
          <epic-links-select></epic-links-select>
        </div>

        <div class="unselectable">

          <button v-if="(selected_task.status === 'canceled') || selected_task.status === 'done'" @click="selected_task.status = 'deleted'" class="btn btn-outline-danger btn-sm mr-2"><i class="fe fe-archive mr-2"></i>{{ $t("common.edit_task.archive") }}</button>
          <button v-if="selected_task.status !== 'canceled' && selected_task.status !== 'done' && selected_task.status !== 'deleted'" @click="selected_task.status = 'canceled'" class="btn btn-light btn-sm"><i class="fe fe-trash-2 mr-2"></i>{{ $t("common.edit_task.cancel_task") }}</button>
          <button v-if="selected_task.status === 'deleted'" @click="selected_task.status = 'canceled'" class="btn btn-warning btn-sm float-left "><i class="fe fe-refresh-ccw mr-2"></i>{{ $t("common.edit_task.restore") }}</button>
<!--          <button class="btn text-secondary btn-sm btn-link float-right mr-2">{{ $t("common.edit_task.more_options") }}</button>-->
          <edit-task-options :task-id="selected_task._id" @duplicate-task="duplicateTask" @rename-task="renameTask"></edit-task-options>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import NewPersonSelect from './filters/NewPersonSelect';
  import ProjectSelect from '../elements/ProjectSelect';
  import SectionSelect from '../elements/SectionSelect';
  import DurationPicker from '../elements/DurationPicker';
  import DateSelect from '../elements/DateSelect';
  import PrioritySelect from '../elements/PrioritySelect';
  import EpicLinksSelect from '../elements/EpicLinksSelect';
  import RichTextEditor from '../elements/RichTextEditor';
  import Subtasks from './editTask/EditTaskSubtasks';
  import EditTaskOptions from './editTask/EditTaskOptions';
  import SubtasksIcon from '../icons/SubtasksIcon';

  import EditTaskComments from './editTask/EditTaskComments';

  import { formatDateMixin } from '@/mixins/formatDateMixin';

  // import vueFilePond from 'vue-filepond';

  import 'filepond/dist/filepond.min.css';
  import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
  const moment = require('moment');
  // const FilePond = vueFilePond();

  export default {
    name: 'edit_task',
    mixins: [formatDateMixin],
    data () {
      return {
        myFiles: ['https://vuejsexamples.com/content/images/2019/10/Vue-Stripe-Menu.jpg'],
        show_description: false,
        show_subtask: false,
        show_add_attachment: false,
        loading: false,
        time_out_name: null,
        time_out_description: null,
        logFor: '',
        logForDay: 0,
      };
    },
    props: {
      is_modal_mode: {
        default: false,
      },
    },
    computed: {
      ...mapGetters([
        'window',
        'account',
        'task_template',
        'selected_project_id',
        'selected_account_id',
        'selected_task',
      ]),
    },
    watch: {
      logForDay: function (newValue) {
        const today = moment().startOf('day').add(newValue, 'days');
        this.logFor = this.formatDate(today);
        this.selected_task.duration_actual_date = this.logFor;
      },
      'selected_task.epic_links': function () {
        this.updateTask();
      },
      'selected_task.project_id': function () {
        this.updateTask();
      },
      'selected_task.duration_actual': function () {
        this.updateTask();
      },
      'selected_task.duration': function () {
        this.updateTask();
      },
      'selected_task.deadline_date': function () {
        this.updateTask();
      },
      'selected_task.plan_date': function () {
        this.updateTask();
      },
      'selected_task.assignee': function () {
        this.updateTask();
      },
      'selected_task.status': function () {
        this.updateTask();
      },
      'selected_task.priority': function () {
        this.updateTask();
      },
      'selected_task.section_id': function () {
        this.updateTask();
      },
      'selected_task.name': function () {
        if (!this.loading) {
          clearTimeout(this.time_out_name);
          const task = Object.assign(this.selected_task, { token: localStorage.getItem('token') });
          if (!task.deadline_date) { task.deadline_date = null; }
          if (!task.plan_date) { task.plan_date = null; }
          task.name = task.name.replace(/(\r\n|\n|\r)/gm, '');
          this.time_out_name = setTimeout(() => {
            this.$socket.emit('server_update_task', task);
          }, 1000);
        }
      },
      'selected_task.description': function () {
        if (!this.loading) {
          clearTimeout(this.time_out_description);
          const task = Object.assign(this.selected_task, { token: localStorage.getItem('token') });
          if (!task.deadline_date) { task.deadline_date = null; }
          if (!task.plan_date) { task.plan_date = null; }
          this.time_out_description = setTimeout(() => {
            this.$socket.emit('server_update_task', task);
          }, 1000);
        }
      },
    },
    methods: {
      closeModal () {
        this.selected_task.name = this.selected_task.name.replace(/(\r\n|\n|\r)/gm, '');
        if (this.is_modal_mode) {
          this.$modal.hide('editTaskModal');
        }
      },
      renameTask () {
        this.$refs.myTextarea.$el.focus();
      },
      duplicateTask () {
        if (this.is_modal_mode) {
          this.$modal.hide('editTaskModal');
        }
      },
      updateTask () {
        if (!this.loading) {
          const task = Object.assign(this.selected_task, { token: localStorage.getItem('token') });
          if (!task.deadline_date) { task.deadline_date = null; }
          if (!task.plan_date) { task.plan_date = null; }
          this.$socket.emit('server_update_task', task);
        }
      },
    },

    mounted () {
      this.loading = true;

      const today = moment().startOf('day');
      this.logFor = this.formatDate(today);
      this.logForDay = 0;
      this.selected_task.duration_actual_date = this.logFor;
      setTimeout(() => { this.loading = false; }, 400);
      this.show_description = !!(this.selected_task && this.selected_task.description !== '<p></p>' && this.selected_task.description.length > 0);
      this.show_subtask = !!(this.selected_task && this.selected_task.sub_tasks_count);

      this.show_subtask = !!(this.selected_task && this.selected_task.sub_tasks_count);
    },

    components: {
      RichTextEditor,
      DurationPicker,
      SectionSelect,
      NewPersonSelect,
      ProjectSelect,
      DateSelect,
      PrioritySelect,
      EpicLinksSelect,
      // FilePond,
      SubtasksIcon,
      Subtasks,
      EditTaskOptions,
      EditTaskComments,
    },
  };
</script>

<style>

</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  ::-webkit-scrollbar {
    display: none;
  }

  .taskName {
    font-style: normal;
    font-weight: 500;
    font-size: 1.25rem;
    text-shadow: 0 0.5px gainsboro;
  }

  .leftLabels {
    font-size: 1.2rem;
  }

  .animated {
    -webkit-transition: all 0.5s ease-in-out;
    -moz-transition: all 0.5s ease-in-out;
    -ms-transition: all 0.5s ease-in-out;
    -o-transition: all 0.5s ease-in-out;
    transition: all 0.5s ease-in-out;
  }

  .animated:hover {
    -webkit-transition: all 0.5s ease-in-out;
    -moz-transition: all 0.5s ease-in-out;
    -ms-transition: all 0.5s ease-in-out;
    -o-transition: all 0.5s ease-in-out;
    transition: all 0.5s ease-in-out;
    background-color: #F8F9FC;
  }
</style>
